export interface IHalfPageManagerState {
  contentElement: HTMLElement | undefined;
  contentHeight: number;
  repeaterBannerInsertCount: number;
  repeaterBannerList: Array<HTMLElement>;
  repeaterTimer: ReturnType<typeof setInterval> | null;
  elementToInsertRepeaterInto: HTMLElement | undefined;
  lastBannerHeight: number;
}

class HalfPageManagerState implements IHalfPageManagerState {
  contentElement: HTMLElement | undefined;

  contentHeight: number = 0;

  repeaterBannerInsertCount: number = 0;

  repeaterBannerList: Array<HTMLElement> = [];

  repeaterTimer: ReturnType<typeof setInterval> | null = null;

  elementToInsertRepeaterInto: HTMLElement | undefined;

  lastBannerHeight: number = 0;

  private static instance: HalfPageManagerState;

  static getInstance() {
    if (this.instance) {
      return this.instance;
    }
    this.instance = new HalfPageManagerState();
    return this.instance;
  }

  setContentElement(el: HTMLElement | undefined): void {
    this.contentElement = el;
  }

  setContentHeight(height: number): void {
    this.contentHeight = height;
  }

  setRepeaterBannerInsertCount(count: number): void {
    this.repeaterBannerInsertCount = count;
  }

  setRepeaterTimer(timer: ReturnType<typeof setInterval> | null): void {
    this.repeaterTimer = timer;
  }

  setElementToInsertRepeaterInto(el: HTMLElement): void {
    this.elementToInsertRepeaterInto = el;
  }

  setLastBannerHeight(height: number): void {
    this.lastBannerHeight = height;
  }

  pushToRepeaterBannerList(el: HTMLElement): void {
    this.repeaterBannerList.push(el);
  }

  emptyRepeaterBannerList(): void {
    this.repeaterBannerList = [];
  }

  getContentElement(): HTMLElement | undefined {
    return this.contentElement;
  }

  getContentHeight(): number {
    return this.contentHeight;
  }

  getRepeaterBannerInsertCount(): number {
    return this.repeaterBannerInsertCount;
  }

  getRepeaterBannerList(): Array<HTMLElement> {
    return this.repeaterBannerList;
  }

  getRepeaterTimer(): ReturnType<typeof setInterval> | null {
    return this.repeaterTimer;
  }

  getElementToInsertRepeaterInto(): HTMLElement | undefined {
    return this.elementToInsertRepeaterInto;
  }

  getLastBannerHeight(): number {
    return this.lastBannerHeight;
  }
}

export const halfPageManagerState = HalfPageManagerState.getInstance();
